import { hatch } from 'ldrs'

function Loader() {
    return (
            <l-hatch
                size='28'
                stroke='4'
                speed='3.5' 
                color='white' 
            ></l-hatch>
    )
}

export default Loader